import { observer } from 'mobx-react-lite'
import { ReactElement } from 'react'
import { Grid } from '@mui/material'
import { VehicleSpecificationItem } from '../../../../../src/store/models/VehicleSpecification'
import { Translate } from 'common'
import styled from 'styled-components'
import { defaultTheme } from '../../../../../src/theme/index'
import PartsTableHeader from './order/PartsTableHeader'
import { StyledGridTitle, Table } from './SharedCssStyle'

interface SpecificationConfirmationItemsInterface {
  orderSpecifications: Array<VehicleSpecificationItem>
}
export const SpecificationConfirmationItems = observer(
  (props: SpecificationConfirmationItemsInterface): ReactElement => {
    const { orderSpecifications } = props
    if (orderSpecifications?.length <= 0) {
      return null
    }
    return (
      <>
        <Grid container className="mt-5 mb-3 px-4">
          <StyledGridTitle item>{Translate('specifications')}</StyledGridTitle>
        </Grid>
        <Table>
          <PartsTableHeader
            columns={[
              {
                name: 'Description',
                align: 'left',
                visible: true,
                style: { paddingLeft: '24px' },
              },
            ]}
            imageColumnRequired={false}
          />
          <tbody>
            {orderSpecifications?.map((specification) => {
              return (
                <tr key={`${specification.partNumber}`}>
                  <StyledTd>
                    <StyledText>{specification.description}</StyledText>
                    <br />
                    {specification.extendedDescription}
                    {` ${specification.partNumber}`}
                    {specification?.years &&
                      `, ${Translate('years')}: ${specification.years}`}
                    <br />
                    {specification.miscellaneousTexts?.map(
                      (text, index) =>
                        `${text} ${
                          index <= specification.miscellaneousTexts.length
                            ? ''
                            : ', '
                        }`
                    )}
                  </StyledTd>
                </tr>
              )
            })}
          </tbody>
        </Table>
      </>
    )
  }
)

const StyledText = styled.span`
  font-family: 'Roboto', serif;
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  @media print {
    font-weight: normal;
    font-size: 10px;
  }
`

const StyledTd = styled.td`
  box-shadow: inset 0px -1px 0px ${defaultTheme.colors.border};
  text-align: initial;
  padding: 20px 24px;
  @media print {
    font-weight: normal;
    font-size: 10px;
  }
`
